<template>
  <v-container>
    <v-snackbar v-model="snackbar.model" top :color="snackbar.color">
      {{ snackbar.detail }}
    </v-snackbar>

    <SignatureDialog ref="signaturePad" @signed-and-submit="submit" />

    <v-row v-if="profileItems[0].value">
      <v-col cols="12">
        <v-card :loading="loading">
          <v-toolbar>
            <v-toolbar-title>
              Client Details
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-btn text :disabled="!changed || !valid" @click="save">
                <v-icon left>done</v-icon> Save
              </v-btn>
              <v-btn text :disabled="!changed" @click="cancel">
                Cancel
              </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-form v-model="valid">
              <EditForm :items="profileItems" @data-changed="changed = true" ref="editForm"/>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { Getter, Action, namespace } from 'vuex-class'
import { mask } from 'vue-the-mask'
import SignatureDialog from '@/components/dialog/SignatureDialog'
import EditForm from '@/components/public/EditForm'

const ProfileModule = namespace('profile')

@Component({
  components: {
    SignatureDialog,
    EditForm
  },
  directives: {
    mask
  }
})
export default class Profile extends Vue {
  changed = false
  snackbar = { model: false }
  loading = false
  valid = false

  @Getter rules
  @ProfileModule.Getter status
  @ProfileModule.Getter('fields') profileItems
  @ProfileModule.Action setFieldItems
  @Action setPageTitle

  mounted () {
    this.setPageTitle('Profile')
  }

  save () {
    this.loading = true
    const data = this.$refs.editForm.save()

    this.setFieldItems(data)
      .then(resp => {
        this.snackbar = {
          model: true,
          detail: 'Saved!',
          color: 'success'
        }
        this.changed = false
      })
      .catch(err => {
        const resp = err.response
        this.snackbar = {
          model: true,
          detail: `Not able to update profile: ${resp.data.detail}`,
          color: 'error'
        }
      })
      .finally(() => {
        this.loading = false
      })
  }

  cancel () {
    this.$refs.editForm.cancel()
    this.changed = false
  }

  signAndSubmit () {
    this.$refs.signaturePad.open()
  }

  submit (data) {
    this.setFieldItem({
      id: this.profileItems[0].value,
      name: 'signature',
      value: data
    })
      .then(resp => {
        this.snackbar = {
          model: true,
          detail: 'Submit sucessfullty, please waiting for apprival.',
          color: 'success'
        }
      })
      .catch(err => {
        const message = err.response.data.detail
        this.snackbar = {
          model: true,
          detail: `Submit failed, ${message}`,
          color: 'error'
        }
      })
      .finally(() => {
        this.$refs.signaturePad.close()
      })
  }
}
</script>

<style lang="scss" scoped>
i.fa, i.far { font-size: 20px !important; }
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.border-left-1 {
  border-left: 1px solid #ccc;
}
.business-tabs .v-tabs-bar {
  height: 0;
  margin-top: -16px;
}
.menu-text-field.v-text-field--outlined {
  legend { width: 0 !important; }
  .v-label--active { left: -31px !important; padding: 0 4px; }
  .theme--light.v-label { background-color: #fff; }
  theme--dark.v-label { background-color: #424242; }
}
</style>
